// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eCGk","productName":"Table_productName__1tQJN"};